module.exports = __webpack_public_path__ + "img/signed@2x.49d307d8.png";